/**
 * Legacy model slugs generated before slugify() mapped "/" to a separator.
 * "Legacy/Outback" used to collapse into "legacyoutback"; those URLs are
 * indexed, so they 301 to the readable slug instead of 404-ing.
 */
export const MODEL_SLUG_ALIASES: Record<string, string> = {
  cv: "c-v",
  "ruf-turbo-12ctr3": "ruf-turbo-12-ctr3",
  rufturbo12ctr3ctr2017: "rufturbo12-ctr3-ctr2017",
  "t12ctr3ctr-anniversary": "t12-ctr3-ctr-anniversary",
  "turbo12ctr3ctr-anniversary": "turbo12-ctr3-ctr-anniversary",
  "imprezaoutback-sport": "impreza-outback-sport",
  legacyoutback: "legacy-outback",
  golfgti: "golf-gti",
};

export function aliasedModelSlug(slug: string): string | undefined {
  return MODEL_SLUG_ALIASES[slug];
}
